import { render, staticRenderFns } from "./AscAircraftDataContainer.vue?vue&type=template&id=51df2057&"
import script from "./AscAircraftDataContainer.vue?vue&type=script&lang=js&"
export * from "./AscAircraftDataContainer.vue?vue&type=script&lang=js&"
import style0 from "./AscAircraftDataContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
